module.exports = __webpack_public_path__ + "img/telegram.f8887d28.svg";